var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewScannerIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-bullseye",
    "data-name": "Icon awesome-bullseye",
    d: "M7.5.563a7.5,7.5,0,1,0,7.5,7.5A7.5,7.5,0,0,0,7.5.563Zm0,13.065a5.565,5.565,0,1,1,5.565-5.565A5.561,5.561,0,0,1,7.5,13.627Zm0-9.435a3.871,3.871,0,1,0,3.871,3.871A3.871,3.871,0,0,0,7.5,4.192ZM7.5,10A1.935,1.935,0,1,1,9.435,8.063,1.938,1.938,0,0,1,7.5,10Z",
    transform: "translate(0 -0.563)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewScannerIco);
export default __webpack_public_path__ + "static/media/new-scanner-ico.548e56b7.svg";
export { ForwardRef as ReactComponent };